import { deleteApp, getApp, initializeApp } from 'firebase/app'
import {
  createUserWithEmailAndPassword,
  deleteUser,
  getAuth,
  signOut,
} from 'firebase/auth'
import { doc, serverTimestamp, setDoc } from 'firebase/firestore'
import { db } from '../firebase'

export async function createManagedUser({
  email,
  password,
  nickname,
  firstName,
  lastName,
  mobilePhone,
  role,
  department,
  isEmergencyTeamMember = false,
  createdBy,
}) {
  const secondaryApp = initializeApp(
    getApp().options,
    `admin-create-user-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  )
  const secondaryAuth = getAuth(secondaryApp)
  let createdAuthUser = null

  try {
    const credential = await createUserWithEmailAndPassword(
      secondaryAuth,
      email.trim().toLowerCase(),
      password,
    )
    createdAuthUser = credential.user

    await setDoc(doc(db, 'users', createdAuthUser.uid), {
      uid: createdAuthUser.uid,
      email: createdAuthUser.email,
      avatarUrl: '',
      nickname: nickname.trim(),
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      mobilePhone: mobilePhone.trim(),
      role,
      department,
      isEmergencyTeamMember: isEmergencyTeamMember === true,
      status: 'active',
      createdAt: serverTimestamp(),
      createdBy,
    })

    await signOut(secondaryAuth)
    return createdAuthUser.uid
  } catch (error) {
    // Firestore kaydı oluşamazsa yalnız kalan yeni Auth hesabını geri al.
    if (createdAuthUser) {
      try {
        await deleteUser(createdAuthUser)
      } catch (rollbackError) {
        console.error('Yeni kullanıcı Auth geri alma hatası:', rollbackError)
      }
    }
    throw error
  } finally {
    await deleteApp(secondaryApp)
  }
}
